<template>
  <section class="section-welcome bg1-pattern p-t-90 p-b-70">
    <div class="container">
      <div class="row">
        <div class="col-md-6 p-t-45 p-b-30">
          <div class="wrap-text-welcome t-center">
            <span class="tit2 t-center">{{ $t("about.name") }}</span>

            <h3 class="tit3 t-center m-b-35 m-t-5">Welcome</h3>
            <p class="t-center m-b-22 size3 m-l-r-auto">{{ $t("about.describe") }}</p>
            <router-link to="/about" style="text-decoration:none;" class="txt4">
              {{ $t("about.about") }}
              <i class="fa fa-long-arrow-right m-l-10" aria-hidden="true"></i>
            </router-link>
          </div>
        </div>
        <div class="col-md-6 p-b-30">
          <div class="wrap-pic-welcome size2 bo-rad-10 hov-img-zoom m-l-r-auto">
            <img src="/static/images/our-story-01.jpg" alt="IMG-OUR">
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped >
</style>
<script >
export default {
  name: "About"
};
</script>



// WEBPACK FOOTER //
// src/components/About.vue